import React from "react";
import { useResponsiveBelowMd } from "src/hooks";
import { SearchFieldBelowMd } from "./SearchField.belowMd";
import { SearchField } from "./SearchField";
import { SearchFieldProps } from "./types";

export const SearchFieldResponsive = (props: SearchFieldProps) => {
  const isBelowMd = useResponsiveBelowMd();
  return isBelowMd ? (
    <SearchFieldBelowMd {...props} />
  ) : (
    <SearchField {...props} />
  );
};
